module.exports = __webpack_public_path__ + "static/media/face-3.ce7a6b79.jpg";